import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferUpdatePageContainer } from '@occc-app/offerHelpers/components/OfferUpdatePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';
import { getUpdatePageLinks, useGetCampaignName } from '@occc-app/routes/CampaignComponents/utils';

import { PunchcardConfigureFormContainer } from '../components/PunchcardConfigureForm/PunchcardConfigureFormContainer';
import { messages } from '../messages';

export const PunchcardUpdatePageContainer: React.FC = () => {
  const { id: campaignId = '', punchcardId = '' } = useParams<{
    id: string;
    punchcardId: string;
  }>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);
  const getBreadcrumbLinks = (campaignComponentName: string) =>
    getUpdatePageLinks({
      campaignId,
      campaignComponentId: punchcardId,
      campaignName,
      pageTitle: messages.configurePageTitle,
      campaignComponentName,
    });

  return (
    <OfferUpdatePageContainer
      campaignId={campaignId}
      offerId={punchcardId}
      getBreadcrumbLinks={getBreadcrumbLinks}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.ClubOrPunchcard}
      ConfigureFormContainer={PunchcardConfigureFormContainer}
    />
  );
};
